import { take, put, select, fork, call } from 'redux-saga/effects';

import { push } from '@/App/router/actions';
import { INVITE_CONFIRMED, SIGNUP_CONFIRMED } from '@/features/SignUp/constants';
import { getCurrentAccount } from '@/features/Auth/selectors';
import { getAccountChannel, subscribe } from '@/socket/index';
import { List } from 'immutable';
import { ICompany } from '@/types/company';
import { SsoUser } from '@/features/Auth/authSlice';
/* function logTrace(step: string, data?: any) {
    console.info(`%c[TRACE] SignUpSaga: ${step}`, 'color: #e91e63; font-weight: bold;', data || '');
} */

export function* signupConfirmedFlow() {
  yield take(SIGNUP_CONFIRMED);
  //logTrace('SIGNUP_CONFIRMED received. Loading Dashboard Stats...');
  const account: SsoUser | null = yield select(getCurrentAccount);
  if (account) {
    try {
      subscribe(getAccountChannel(account.id), 'account-updated', 'app/Auth/ACCOUNT_UPDATED_PUSHER');
    } catch (e) {
      console.error('[SignUpSaga] Socket subscription failed', e);
    }
  }
  
}
export function* inviteConfirmedFlow() {
  yield take(INVITE_CONFIRMED);
  try {
      
  } catch (e) {
      // ignore
  }
  const account: SsoUser | null = yield select(getCurrentAccount);
  if (account) {
    try {
      subscribe(getAccountChannel(account.id), 'account-updated', 'app/Auth/ACCOUNT_UPDATED_PUSHER');
    } catch (e) {
      console.error('[SignUpSaga] Socket subscription failed', e);
    }
  }
  yield put(push('/onboarding/profile'));
}